__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "onex-digital";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@vfmfe/feedback", "1.0.0-SNAPSHOT", () => (() => (__webpack_require__(973688))), 1);
			register("@vfmfe/feedback", "1.0.6-SNAPSHOT", () => (() => (__webpack_require__(266019))), 1);
			register("@vfmfe/foundations", "2.0.30-SNAPSHOT", () => (() => (__webpack_require__(27799))), 1);
			register("@vfmfe/foundations", "2.1.12-SNAPSHOT", () => (() => (__webpack_require__(190967))), 1);
			register("@vfmfe/foundations", "2.1.4-SNAPSHOT", () => (() => (__webpack_require__(392526))), 1);
			register("i18next", "23.16.8", () => (() => (__webpack_require__(572635))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(440961))), 1);
			register("react-i18next", "15.4.1", () => (() => (__webpack_require__(563710))), 1);
			register("react-i18next", "15.6.1", () => (() => (__webpack_require__(122617))), 1);
			register("react-redux", "9.2.0", () => (() => (__webpack_require__(671468))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(296540))), 1);
			register("redux-thunk", "2.4.2", () => (() => (__webpack_require__(921245))), 1);
			register("redux", "4.2.1", () => (() => (__webpack_require__(177289))), 1);
			register("styled-components", "6.1.19", () => (() => (__webpack_require__(721250))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};